import { render } from "./Combustivel.vue?vue&type=template&id=71aec16d"
import script from "./Combustivel.vue?vue&type=script&lang=js"
export * from "./Combustivel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__